import type { FilterObject } from '@benzinga/quotes-v3-fields-manager';

const isEmptyParameter = (parameter: string): boolean =>
  parameter === null || parameter === undefined || String(parameter).trim() === '';

const OPERATORS_WITHOUT_PARAMETERS = new Set(['isempty', 'notempty']);

export const isUnboundedFilter = (filter: FilterObject): boolean => {
  if (filter.parameters.length === 0) return true;
  if (OPERATORS_WITHOUT_PARAMETERS.has(filter.operator.toLowerCase())) return false;
  return filter.parameters.every(isEmptyParameter);
};

function toQueryFilterString(filter: FilterObject): string | undefined {
  if (isUnboundedFilter(filter)) {
    return undefined;
  }

  const encodedParams = filter.parameters.map(param => encodeURIComponent(String(param))).join(',');
  return `${filter.field}_${filter.operator}_${encodedParams}`;
}

export const toQueryFiltersString = (filters: FilterObject[]): string =>
  filters
    .map(toQueryFilterString)
    .filter((value): value is string => value !== undefined)
    .join(';');
